// Imports
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';

// Views
import MainView from 'Modules/video/views/main';
import VideoDetailView from 'Modules/video/views/videoDetail';
import { HasPermission } from 'Core/security';

// Router
const routerVideo = (props) => {
	const { match } = props;
	const user = useSelector(state => state.securityRedux.user);

	return (
		<Routes>
			{
				HasPermission(user, "vidfleetvideo", [217]) &&
				<Fragment>
					<Route path='/' element={<Navigate to="/app/video/main" />}></Route>
					<Route path='main' element={<MainView />} />
					<Route path='videoDetail/*' element={<VideoDetailView />} />
				</Fragment>
			}
			<Route path="*" element={<Navigate to="/app/error" />} />
		</Routes>
	);
};

export default routerVideo;
